<template>
    <div class="input select" v-bind:class="{'focused': focused, 'filled': value || prompt}">
        <label v-if="label">{{ label }}</label>
        <select ref="input" :value.trim="value" :name="name" @change="onChange" @blur="onBlur" @focus="onFocus"
                :disabled="disabled" :class="lengthType">
            <option v-if="prompt" :value="null">{{ prompt }}</option>
            <option :key="option.id" :selected="option.id === value" :value="option.id" v-for="option in options">
                {{ option.name }}
            </option>
        </select>
        <input-error v-if="v" :v="v" :name="name" @o3-error="error = $event"></input-error>
    </div>
</template>

<script>
import InputMixin from './mixin';

export default {
    mixins: [InputMixin],
    props:  {
        prompt:  {
            type:     String,
            requierd: false,
            default:  () => null,
        },
        options: {
            type:     Array,
            requierd: true
        }
    }
}
</script>
